import { render, staticRenderFns } from "./WcBreadcrumb.vue?vue&type=template&id=36212bea&lang=pug&"
import script from "./WcBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./WcBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./WcBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports